<template>
  <div
    class="voucher-card top-round d-flex flex-column col-xs-12 px-0 py-4"
    :class="{'position-relative':isGiftCardVisible, 'cover-up': isGiftCardVisible}"
  >
    <div v-if="subscriptionPlan.ActivePlan" class="d-flex flex-row justify-content-between align-items-center px-3 mt-3">
      <h6 class="text-white">
        {{ $t('UserProfile.VoucherCard.SubscriptionPlan') }}
        {{ subscriptionPlan.ActivePlan !== undefined ? $t('UserProfile.VoucherCard.'+subscriptionPlan.ActivePlan):"" }}
      </h6>
      <b-button
        v-if="!isGiftCardVisible && subscriptionPlan.IsDailyPlan"
        size="sm"
        variant="danger"
        @click="UnsubscribeUser"
      >
        {{ $t('UserProfile.VoucherCard.Unsubscribe') }}
      </b-button>
    </div>
    <div v-if="!isGiftCardVisible && !subscriptionPlan.IsDailyPlan && !subscriptionPlan.ActivePlan" class="d-flex flex-row justify-content-between align-items-center px-3 mt-3">
      <h6 v-if="subscriptionPlan.ActivePlan!== undefined" class="text-white col-xxs-8 p-0 line-height-2">
        {{ $t('UserProfile.VoucherCard.'+subscriptionPlan.ActivePlan) }}
      </h6>
      <b-button
        :to="{name:'buysubscription'}"
        size="lg"
        variant="secondary"
      >
        {{ $t('UserProfile.VoucherCard.RenewSubscription') }}
      </b-button>
    </div>
    <div v-if="subscriptionPlan.ActivePlan && !subscriptionPlan.IsDailyPlan" class="d-flex flex-row justify-content-between align-items-center mt-3 px-3">
      <h6 class="text-white" v-if="subscriptionPlan.RemainedDays !== 0">
        {{ $t('UserProfile.VoucherCard.RemainedSubscriptionDays', {'days':subscriptionPlan.RemainedDays}) }}
      </h6>
      <b-button
        v-if="!isGiftCardVisible"
        hidden
        size="sm"
        variant="primary"
        @click="ShowGiftCardBox()"
      >
        {{ $t('UserProfile.VoucherCard.IHaveGiftCard') }}
      </b-button>
    </div>
    <div v-if="isGiftCardVisible" class="d-flex flex-column justify-content-between mt-3 px-3">
      <h6 class="text-white">
        {{ $t('UserProfile.VoucherCard.EnterVoucherCode') }}
      </h6>
      <b-input
        dir="ltr"
        class="my-2"
        :placeholder="$t('UserProfile.VoucherCard.VoucherPlaceHolder')"
      />
      <div class="d-flex justify-content-end">
        <b-button
          size="sm"
          variant="warning-light"
          class="mx-2 px-3"
          @click="HideGiftCard()"
        >
          {{ $t('common.cancel') }}
        </b-button>
        <b-button
          size="sm"
          variant="secondary"
          class="px-5"
          @click="HideGiftCard()"
        >
          {{ $t('UserProfile.VoucherCard.ApplyCode') }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'UserProfileSubscribedUserVoucherCard',
  props: {
    subscriptionPlan: Object,
    user: Object
  },
  data () {
    return {
      isGiftCardVisible: false
    }
  },
  methods: {
    ...mapActions({
      showUnsub: 'navigation/showUnsub'
    }),
    UnsubscribeUser () {
      this.showUnsub()
    },
    ShowGiftCardBox () {
      this.isGiftCardVisible = true
    },
    HideGiftCard () {
      this.isGiftCardVisible = false
    }
  }
}
</script>
